import { render, staticRenderFns } from "./ShoppingCartDppOfferRowComponent.vue?vue&type=template&id=485e51ae&scoped=true&"
import script from "./ShoppingCartDppOfferRowComponent.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartDppOfferRowComponent.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartDppOfferRowComponent.vue?vue&type=style&index=0&id=485e51ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485e51ae",
  null
  
)

export default component.exports